import { Html5Qrcode } from "html5-qrcode";
import React, { useState, useEffect, useRef } from "react";
import "./ScannerComponent.scss";
import flash from "./image/flash.svg";
import marked from "./image/marked.svg";
import notMarked from "./image/not-marked.svg";
import { Ticket } from "../../../../../types/types";
import { ScannerComponentsProps } from "../../../../../types/props";
import { checkAuth, getAuthToken } from "../../../../../utils/utils";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../../../../../config/api";

export const ScannerComponent = ({
  onSwitch,
  id,
  eventName,
}: ScannerComponentsProps) => {
  const [coincide, setCoincide] = useState<boolean | null>(null);
  const dataRef = useRef<string | null>(null);
  const [notification, setNotification] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const mediaStreamRef = useRef<MediaStream | null>(null);
  const [ticket, setTicket] = useState<Ticket[] | null>(null);
  const url = `${API_BASE}`;
  const navigate = useNavigate();

  if (!checkAuth()) {
    navigate("/registrationPage");
  }
  const token = getAuthToken();

  useEffect(() => {
    const html5Qrcode = new Html5Qrcode("qrCodeContainer");
    const config = {
      fps: 10,
      qrbox: { width: 230, height: 230 },
      showTorchButtonIfSupported: true,
    };

    const onScan = async (decodedText: string) => {
      const response = await fetch(`${API_BASE}/tickets/check/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ticket_number: Number(decodedText),
          event_id: id,
        }),
      });

      return await response.json();
    };

    const getTicket = async (decodedText: string) => {
      try {
        const response = await fetch(
          `${url}/tickets/${id}/?ticket_number=${decodedText}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Ошибка ${response.status}: ${response.statusText}`);
        }

        return await response.json();
      } catch (error) {
        console.error("Ошибка сервера:", error);
        return null;
      }
    };

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        mediaStreamRef.current = stream;

        if (html5Qrcode) {
          html5Qrcode.start(
            { facingMode: "environment" },
            config,
            async (decodedText: string) => {
              if (dataRef.current) {
                return;
              }

              dataRef.current = decodedText;

              const response = await onScan(decodedText);
              console.log(response);
              if (response.success) {
                setNotification("Отмечен");
                setCoincide(true);
                setTicket(await getTicket(decodedText));
              } else if (response.detail) {
                if (response.detail === "Билет уже использован.") {
                  setNotification("Уже был отмечен");
                  setCoincide(false);
                  setTicket(await getTicket(decodedText));
                } else {
                  setNotification("Не найден");
                  setCoincide(false);
                }
              }

              setTimeout(() => (dataRef.current = null), 3000);
            },
            () => {}
          );
        }
      })
      .catch(() => {
        setError("Необходимо разрешить доступ к камере.");
      });

    return () => {
      if (mediaStreamRef.current) {
        const tracks = mediaStreamRef.current.getTracks();
        tracks.forEach((track) => track.stop());
        mediaStreamRef.current = null;
      }

      if (html5Qrcode && html5Qrcode.isScanning) {
        html5Qrcode
          .stop()
          .catch((err) => console.error("Error stopping scanner:", err));
      }
    };
  }, [onSwitch, id, token, url]);

  useEffect(() => {
    if (coincide !== null) {
      const timeout = setTimeout(() => setCoincide(null), 3000);
      return () => clearTimeout(timeout);
    }
  }, [coincide]);

  useEffect(() => {
    if (error) {
      alert(error);
      console.log(error);
      setError(null);
      onSwitch();
    }
  }, [error, onSwitch]);

  return (
    <div
      className={`scannerQr ${
        coincide ? "found" : coincide === false ? "not-found" : ""
      }`}
    >
      <div className="scannerQr__top-wrapper">
        <h2 className="scannerQr__title">Событие: {eventName}</h2>
        <h2 className="scannerQr__subtitle">Наведите на QR-код</h2>
      </div>
      <div id="qrCodeContainer"></div>
      <button className="scannerQr__btn-flash">
        <img src={flash} alt="flash" />
      </button>
      {coincide ||
      (coincide === false && notification === "Уже был отмечен") ? (
        <div
          className={coincide ? "scannerQr__found-qr" : "scannerQr__used-qr"}
        >
          <h3 className="scannerQr__name">{ticket?.[0].user_name}</h3>
          <div className="scannerQr__info">
            <span>{ticket?.[0].user_email}</span>
            <span>Билет: {ticket?.[0].ticket_number}</span>
          </div>
          <div className="scannerQr__mark">
            <img
              src={coincide ? marked : notMarked}
              alt={coincide ? "marked" : "not-marked"}
            />
            <span>{notification}</span>
          </div>
        </div>
      ) : (
        <></>
      )}
      {coincide === false && notification === "Не найден" && (
        <div className="scannerQr__not-found-qr">
          <img src={notMarked} alt="not-marked" />
          <span>{notification}</span>
        </div>
      )}
      <button className="scannerQr__btn-search" onClick={onSwitch}>
        Поиск участников
      </button>
    </div>
  );
};
